import { ProblemDescription } from '@/domain/entities/problem/problemDescription'
import { ProblemRepository } from '@/domain/repositories/problem/ProblemRepository'
import { DisplayLanguageType } from '@/domain/value_objects/language/displayLanguageType'

export class GetProblemDescriptionUseCase {
  constructor(private repository: ProblemRepository) {}

  async getProblemDescription(displayLanguage: DisplayLanguageType, problemId: string): Promise<ProblemDescription> {
    try {
      const data = await this.repository.getProblemDescription(displayLanguage, problemId)
      return data
    } catch (error) {
      console.error(`Error in GetProblemDescriptionUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
